var Component = require("../../model/Component");

Component.registerSubTypeDefaulter('timeline', function () {
  // Only slider now.
  return 'slider';
});


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/timeline/typeDefaulter.js
// module id = 911
// module chunks = 1